import { takeLatest, put, call, all } from 'redux-saga/effects';
import {
  setLoading,
  setSchoolList,
  setSchoolCreation,
  clearSchoolData,
  setListSchoolModule,
  setDistrictList,
  setLoadingDistrict,
  setLoadingProvince,
  setLoadingWard,
  setProvinceList,
  setWardList,
  setSchoolModuleList,
  setPersonnelList,
  setSumPersonnelList,
  setPersonnelLoading,
  setPersonnelError,
  setSchoolYearsList,
  setSuccessfulSchoolYear,
  setPreviewUpgradeClass,
  setPreviewLoading,
  setLoadingUpgradeClassLogs,
  setUpgradeClassLogs,
  setLoadingDownloadTemplateSchool,
  setTemplateSchoolFile,
  setLoadingSchoolModuleGrade,
  setLoadingDeleteSchoolModuleGrade,
  setLoadingDeleteSchool,
  setDeleteSchoolSuccess,
  incrementSchoolModuleGradeSuccess,
} from '@store/reducers/schoolReducer';
import { resourceService, fileService } from '@libs/axios';

/** GET /api/school_module/?school_id= — array or paginated `results`. */
function normalizeSchoolModuleApiRows(data: any): any[] {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.results)) return data.results;
  return [];
}

function* reloadSchoolModuleListRows(
  schoolId: string,
): Generator<any, void, any> {
  try {
    const response: ResponseType = yield call(
      resourceService.get,
      API_URL + `/api/school_module/`,
      { params: { school_id: schoolId } },
    );
    if (response.status === 200) {
      yield put(setSchoolModuleList(normalizeSchoolModuleApiRows(response.data)));
    }
  } catch (error: any) {
    console.error(error);
  }
}
import {
  fetchingSchoolList,
  createSchool,
  getSchoolDetail,
  updateSchool,
  clearSchool,
  fetchListSchoolModules,
  fetchDistrictList,
  fetchProviceList,
  fetchWardList,
  fetchBankSupportList,
  fetchSchoolModuleList,
  addSchoolModule,
  removeSchoolModule,
  fetchSchoolYearsList,
  fetchUpgradeClassLogs,
  assignSchoolYear,
  createSchoolYear,
  updateSchoolYear,
  fetchPersonnelListRequest,
  fetchPersonnelListSuccess,
  fetchPersonnelListFailure,
  fetchPreviewUpgradeClass,
  confirmUpgradeClass,
  FETCH_PERSONNEL_LIST_REQUEST,
  FETCHING_SCHOOL_LIST,
  CREATE_SCHOOL,
  GET_SCHOOL_DETAIL,
  CLEAR_SCHOOL,
  UPDATE_SCHOOL,
  FETCH_SCHOOL_MODULES,
  FETCHING_PROVINCE_LIST,
  FETCHING_DISTRICT_LIST,
  FETCHING_WARD_LIST,
  FETCH_SCHOOL_MODULES_LIST,
  ADD_SCHOOL_MODULE,
  REMOVE_SCHOOL_MODULE,
  FETCH_SCHOOL_YEARS_LIST,
  CREATE_SCHOOL_YEAR,
  UPDATE_SCHOOL_YEAR,
  ASSIGN_SCHOOL_YEAR,
  FETCH_PREVIEW_UPGRADE_CLASS,
  CONFIRM_UPGRADE_CLASS,
  FETCH_UPGRADE_CLASS_LOGS,
  downloadTemplateAccountSchoolList,
  DOWNLOAD_TEMPLATE_ACCOUNT_SCHOOL_LIST,
  createSchoolModuleGrade,
  deleteSchoolModuleGrade,
  deleteSchool,
} from '@store/actions/schoolActions';
import { toast } from 'react-toastify';
import { history } from '@utils/BrowserHistory';
import { convertDate } from '@utils/DateTimeUtils';
import { ResponseType } from '@store/index';
import dayjs from "dayjs";

const API_URL = process.env.REACT_APP_API_URL;

function* fetchSchoolListData(action: ReturnType<typeof fetchingSchoolList>) {
  const { name, province, district, ward, status, page, page_size, newProvince, newWard, schoolType, partner } = action.payload;
  yield put(setLoading(true));
  try {
    const response: ResponseType = yield call(
      resourceService.get,
      API_URL + '/api/schools/', {
      params: {
        name,
        province,
        district,
        ward,
        ward2:newWard,
        province2:newProvince,
        school_type:schoolType,
        status,
        schools_address:name,
        ...(partner !== null && partner !== undefined && partner !== '' ? { partner } : {}),
        page: page,
        page_size: page_size,
      }
    }
    );

    if (response?.data) {
      yield put(setSchoolList(response.data));
      yield put(setLoading(false));
    }
  } catch (e: any) {
    yield put(setLoading(false));
    let error: Error = e;
    console.log(error);
  }
}

function* createSchoolSaga(action: ReturnType<typeof createSchool>) {
  yield put(setLoading(true));
  const currentYear = new Date().getFullYear();
  const defaultSchoolYear = {
    year: currentYear,
    start_date: dayjs(`${currentYear}-09-05`).format("YYYY-MM-DD"),
    end_date: dayjs(`${currentYear + 1}-05-31`).format("YYYY-MM-DD"),
    name: `Năm học ${currentYear} - ${currentYear + 1}`,
  };
  try {
    const response: ResponseType = yield call(resourceService.post, API_URL + '/api/schools/', {
      ...action.payload,
      wards_2_id : action.payload.wards_code_2,
      birth_date: convertDate(action.payload?.birth_date),
    });
    if (response.status == 201) {
      toast.success('Tạo trường học mới thành công');
      const responseCreateSchoolYear: ResponseType = yield call(resourceService.post, API_URL + `/api/school_years/${response.data.id}/`, defaultSchoolYear);
      if (response.status == 201) {
        toast.success('Tạo năm học mới thành công');
        const response: ResponseType = yield call(resourceService.put, API_URL + `/api/update_year_school/`, {school_id: responseCreateSchoolYear.data.school,year_id:responseCreateSchoolYear.data.id});
        if (response.status == 200) {
          toast.success('Gán năm học thành công');
        }
      history.push(`/admin/detail/?mode=view&id=${responseCreateSchoolYear?.data?.school}`);
      }
      yield put(setLoading(false));
      yield put(setSchoolCreation({
          schools_bank_id: response.data?.schools_bank_id,
          wards_code: response.data?.wards?.code,
          wards_code_2: response.data?.wards_2?.id,
          district: response.data?.wards?.district?.code,
          province: response.data?.wards?.district?.province?.code,
          province_2: response.data?.wards_2?.province_code_2,
          schools_bank_account_name: response.data?.schools_bank_account_name,
          schools_bank_account_number:
          response.data?.schools_bank_account_number,
          schools_email: response.data?.schools_email,
          schools_fax: response.data?.schools_fax,
          schools_hot_line: response.data?.schools_hot_line,
          schools_tele: response.data?.schools_tele,
          schools_phone: response.data?.schools_phone,
          postal_code: response.data?.postal_code,
          schools_address: response.data?.schools_address,
          schools_address_2: response.data?.schools_address_2,
          vice_principal_name: response.data?.vice_principal_name,
          principal_name: response.data?.principal_name,
          organization_name: response.data?.organization_name,
          schools_type: response.data?.schools_type,
          birth_date: response.data?.birth_date,
          en_name: response.data?.en_name,
          other_name: response.data?.other_name,
          name: response.data?.name,
          status: response.data?.status,
          partner: response.data?.partner ?? null,
        }));
    }

  } catch (error: any) {
    toast.error('Tạo trường học mới thất bại');
    yield put(setLoading(false));
  }
}

function* getSchoolDetailSaga(action: any) {
  const { id } = action.payload;
  yield put(setLoading(true));
  try {
    const response: ResponseType = yield call(resourceService.get, API_URL + `/api/schools/${id}/`);
    if (response?.data) {
      yield put(
        setSchoolCreation({
          schools_bank_id: response.data?.schools_bank_id,
          wards_code: response.data?.wards?.code,
          wards_code_2: response.data?.wards_2?.id,
          district: response.data?.wards?.district?.code,
          province: response.data?.wards?.district?.province?.code,
          province_2: response.data?.wards_2?.province_code_2,
          schools_bank_account_name: response.data?.schools_bank_account_name,
          schools_bank_account_number:
          response.data?.schools_bank_account_number,
          schools_email: response.data?.schools_email,
          schools_fax: response.data?.schools_fax,
          schools_hot_line: response.data?.schools_hot_line,
          schools_tele: response.data?.schools_tele,
          schools_phone: response.data?.schools_phone,
          postal_code: response.data?.postal_code,
          schools_address: response.data?.schools_address,
          schools_address_2: response.data?.schools_address_2,
          vice_principal_name: response.data?.vice_principal_name,
          principal_name: response.data?.principal_name,
          organization_name: response.data?.organization_name,
          schools_type: response.data?.schools_type,
          birth_date: response.data?.birth_date,
          en_name: response.data?.en_name,
          other_name: response.data?.other_name,
          name: response.data?.name,
          status: response.data?.status,
          partner: response.data?.partner ?? null,
        }),
      );
      yield put(setLoading(false));
    }
  } catch (error: any) {
    yield put(setLoading(false));
    console.log(error);
  }
}

function* clearSchoolSaga(action: any) {
  yield put(clearSchoolData());
}

function* updateSchoolSaga(action: any) {
  yield put(setLoading(true));
  try {
    const { data, id } = action.payload;
    const response: ResponseType = yield call(resourceService.put, API_URL + `/api/schools/${id}/`, {
      ...data,
       wards_2_id : data.wards_code_2,
      birth_date: convertDate(data?.birth_date),

    });
    if (response.status == 200) {
      toast.success('Chỉnh sửa thông tin trường học thành công');
      yield put(setLoading(false));
      yield put(
        setSchoolCreation({
          schools_bank_id: response.data?.schools_bank_id,
          wards_code: response.data?.wards?.code,
          wards_code_2: response.data?.wards_2?.id,
          district: response.data?.wards?.district?.code,
          province: response.data?.wards?.district?.province?.code,
          province_2: response.data?.wards_2?.province_code_2,
          schools_bank_account_name: response.data?.schools_bank_account_name,
          schools_bank_account_number:
          response.data?.schools_bank_account_number,
          schools_email: response.data?.schools_email,
          schools_fax: response.data?.schools_fax,
          schools_hot_line: response.data?.schools_hot_line,
          schools_tele: response.data?.schools_tele,
          schools_phone: response.data?.schools_phone,
          postal_code: response.data?.postal_code,
          schools_address: response.data?.schools_address,
          schools_address_2: response.data?.schools_address_2,
          vice_principal_name: response.data?.vice_principal_name,
          principal_name: response.data?.principal_name,
          organization_name: response.data?.organization_name,
          schools_type: response.data?.schools_type,
          birth_date: response.data?.birth_date,
          en_name: response.data?.en_name,
          other_name: response.data?.other_name,
          name: response.data?.name,
          status: response.data?.status,
          partner: response.data?.partner ?? null,
        }),
      );
      history.push(`/admin/detail/?mode=view&id=${response?.data?.id}`);
    }
  } catch (error: any) {
    toast.error('Chỉnh sửa thông tin trường học mới thất bại');
    yield put(setLoading(false));
  }
}

function* fetchProviceListSaga(action: any) {
  try {
    yield put(setLoadingProvince(true));
    const response: ResponseType = yield call(
      resourceService.get,
      API_URL + `/api/provinces/?page=1&page_size=100`,
    );
    if (response.status === 200) {
      yield put(setProvinceList(response.data?.results));
      yield put(setLoadingProvince(false));
    }
  } catch (error: any) {
    yield put(setLoadingProvince(false));
    console.log(error);
  }
}

function* fetchDistricListSaga(action: any) {
  try {
    const { provinceId } = action.payload;
    yield put(setLoadingDistrict(true));
    const response: ResponseType = yield call(
      resourceService.get,
      API_URL + `/api/districts/?province=${provinceId}&page_size=500`,
    );
    if (response.status === 200) {
      yield put(setDistrictList(response.data?.results));
      yield put(setLoadingDistrict(false));
    }
  } catch (error: any) {
    yield put(setLoadingDistrict(false));
    console.log(error);
  }
}

function* fetchWardListSaga(action: any) {
  try {
    yield put(setLoadingWard(true));
    const { districtId } = action.payload;
    const response: ResponseType = yield call(
      resourceService.get,
      API_URL + `/api/wards?district=${districtId}&page_size=500`,
    );
    if (response.status === 200) {
      yield put(setWardList(response.data?.results));
      yield put(setLoadingWard(false));
    }
  } catch (error: any) {
    yield put(setLoadingWard(false));
    console.log(error);
  }
}

function* fetchSchoolModuleListSaga(action: any) {
  const { schoolId } = action.payload;
  yield* reloadSchoolModuleListRows(String(schoolId));
}

function* addSchoolModuleSaga(action: any) {
  const { moduleIds, schoolId } = action.payload;
  yield put(setLoading(true));
  try {
    const moduleIdsArray = Array.isArray(moduleIds) ? moduleIds : [moduleIds];
    // Process all module additions sequentially
    for (const moduleId of moduleIdsArray) {
      const response: ResponseType = yield call(resourceService.post, API_URL + `/api/schools/${schoolId}/add_module/`, { module: moduleId });
      // Continue only if the current addition was successful
      if (response.status !== 201) {
        throw new Error('Failed to add one or more modules');
      }
    }

    yield* reloadSchoolModuleListRows(String(schoolId));
    yield put(setLoading(false));
    toast.success("Đăng ký môn học thành công !");
  }
  catch (error: any) {
    const detailError = error.response.data['module'];
    toast.error(`Đăng ký môn học thất bại!`);
    yield put(setLoading(false));
    console.error(error);
  }
}

function* removeSchoolModuleSaga(action: any) {
  const { moduleIds, schoolId } = action.payload;
  yield put(setLoading(true));
  try {
    const moduleIdsArray = Array.isArray(moduleIds) ? moduleIds : [moduleIds];
    // Process all module removals sequentially
    for (const moduleId of moduleIdsArray) {
      const response: ResponseType = yield call(resourceService.delete, API_URL + `/api/schools/${schoolId}/remove_module/`, { data: { module: moduleId } });
      // Continue only if the current removal was successful
      if (response.status !== 204) {
        throw new Error('Failed to remove one or more modules');
      }
    }

    yield* reloadSchoolModuleListRows(String(schoolId));
    yield put(setLoading(false));
    toast.success("Xoá Môn học thành công !");
  }
  catch (error: any) {
    const detailError = error.response.data['module'];
    toast.error(`Xoá Môn học thất bại: ${detailError}`);
    yield put(setLoading(false));
    console.error(error);
  }
}

// Worker saga for fetching personnel list
function* fetchPersonnelListSaga(action: ReturnType<typeof fetchPersonnelListRequest>): Generator<any, void, any> {
  try {
    const { schoolId, name, enrollment, enroll_status, course_id, page, page_size } = action.payload;

    // Build URL with parameters
    let url = `${API_URL}/api/get_teacher_schools/?school_id=${schoolId}`;
    if (name) {
      url += `&name=${name}`;
    }
    const params: any = {
      enrollment,
      enroll_status,
      course_id,
      page,
      page_size
    }
    const response = yield call(
      resourceService.get,
      url,
      { params }
    );

    if (response?.status === 200) {
      // Map API response to table format
      const mappedData = response.data.results.map((item: any) => ({
        id: item.id,
        code: item.code,
        name: item.name || item.full_name,
        username: item.username,
        email: item.email,
        phone: item.phone || '',
        role: item.role || 'Teacher',
        enrollment: item.enrollment
      }));
      const sumPersonnelList = response.data.total_count
      // Dispatch Redux Toolkit actions
      yield put(setPersonnelList(mappedData));
      yield put(setSumPersonnelList(sumPersonnelList));

      yield put(setPersonnelLoading(false));

      // Also dispatch traditional action
      yield put(fetchPersonnelListSuccess(mappedData));
    }
  } catch (error: any) {
    yield put(setPersonnelError(error.message));
    yield put(setPersonnelLoading(false));
    yield put(fetchPersonnelListFailure(error));
    toast.error('Không thể tải danh sách nhân sự');
  }
}

function* fetchListSchoolModulesSaga(action: any) {
  try {
    const { page, pageSize, schoolId } = action.payload;
    yield put(setLoading(true));
    const response: ResponseType = yield call(
      resourceService.get,
      API_URL + `/api/school_modules/?page=${page}&page_size=${pageSize}&school=${schoolId}`,
    );
    if (response.status === 200) {
      yield put(setListSchoolModule(response.data));
      yield put(setLoading(false));
    }
  } catch (error: any) {
    yield put(setLoading(false));
    console.error(error);
  }
}
function* fetchSchoolYearListData(action: ReturnType<typeof fetchingSchoolList>) {
  yield put(setLoading(true));
  const {schoolId,params } = action.payload;

  try {
    const response: ResponseType = yield call(
      resourceService.get,
      API_URL + `/api/school_years/${schoolId}/`,{params:params}
    );

    if (response?.data) {
      yield put(setSchoolYearsList(response.data));
      yield put(setLoading(false));
    }
  } catch (e: any) {
    yield put(setLoading(false));
    let error: Error = e;
    console.log(error);
  }
}

function* createSchoolYearSaga(action: ReturnType<typeof createSchoolYear>) {
  yield put(setLoading(true));
  const {schoolId,autoCreateSchoolYear,data} = action.payload;
  console.log("data",data)
  try {
    const response: ResponseType = yield call(resourceService.post, API_URL + `/api/school_years/${schoolId}/`, data);
    if (response.status == 201) {
      toast.success('Tạo năm học mới thành công');
      yield put(setLoading(false));
      yield put(setSuccessfulSchoolYear(response.data));
      const fetchResponse: ResponseType = yield call(
      resourceService.get,
      API_URL + `/api/school_years/${schoolId}/`,{params:{page_size:100,order_by: 'desc',}}
    );

    if (fetchResponse?.data) {
      yield put(setSchoolYearsList(fetchResponse.data));
      yield put(setLoading(false));
    }
    if(autoCreateSchoolYear){
      const response: ResponseType = yield call(resourceService.post, API_URL + `/api/upgrade_classes/`, {school_id:Number(schoolId)});
    if (response.status == 200) {
      toast.success('Nâng lớp thành công');
      // yield put(setPreviewLoading(false));
    }
    }

    }
  } catch (error: any) {
    toast.error('Tạo năm học mới thất bại');
    yield put(setLoading(false));
  }
}

function* updateSchoolYearSaga(action: ReturnType<typeof updateSchoolYear>) {
  yield put(setLoading(true));
  const {schoolId,id,data} = action.payload;
  try { 
    const response: ResponseType = yield call(resourceService.put, API_URL + `/api/school_years/${schoolId}/${id}/`, data);
    if (response.status == 200) {
      toast.success('Cập nhật năm học thành công');
      yield put(setLoading(false));
      const params ={
        order_by: 'desc',
      }
      const response: ResponseType = yield call(resourceService.get, API_URL + `/api/school_years/${schoolId}/`,{params:params});
      if (response?.data) {
        yield put(setSchoolYearsList(response.data));
      }
      }
    else {
      toast.error('Cập nhật năm học thất bại');
      yield put(setLoading(false));
    }
  }
  catch (error: any) {
    toast.error('Cập nhật năm học thất bại');
    yield put(setLoading(false));
  }
}

function* assignSchoolYearSaga(action: ReturnType<typeof assignSchoolYear>) {
  yield put(setLoading(true));
  try {
    const {id,schoolId } = action.payload;
    const data = {
      school_id:schoolId,
      year_id:id
    }
    const response: ResponseType = yield call(resourceService.put, API_URL + `/api/update_year_school/`, data);
    if (response.status == 200) {
      toast.success('Gán năm học thành công');
      yield put(setLoading(false));
    }
  } catch (error: any) {
    toast.error('Gán năm học thất bại');
    yield put(setLoading(false));
  }
}
function* fetchPreviewUpgradeClassesSaga(action: ReturnType<typeof createSchoolYear>) {
  yield put(setPreviewLoading(true));
  const {schoolId} = action.payload;
  try {
    const response: ResponseType = yield call(resourceService.post, API_URL + `/api/preview_upgrade_classes/`, {school_id:schoolId});
    if (response.status == 200) {
      yield put(setPreviewLoading(false));

      yield put(setPreviewUpgradeClass(response.data));

    }
  } catch (error: any) {
    toast.error('Lấy dữ liệu nâng lớp thất bại');
    yield put(setPreviewLoading(false));
  }
}
function* fetchUpgradeClassesLogsSaga(action: ReturnType<typeof fetchUpgradeClassLogs>) {
  yield put(setLoadingUpgradeClassLogs(true));
  const {schoolId,params} = action.payload;
  try {
    const response: ResponseType = yield call(resourceService.get, API_URL + `/api/upgrade_class_logs/${schoolId}/`, {params:params});
    if (response.status == 200) {
      yield put(setLoadingUpgradeClassLogs(false));

      yield put(setUpgradeClassLogs(response.data));

    }
  } catch (error: any) {
    yield put(setLoadingUpgradeClassLogs(false));
  }
}


function* confirmUpgradeClassSaga(action: ReturnType<typeof confirmUpgradeClass>) {
  // yield put(setPreviewLoading(true));
  const {schoolId} = action.payload;
  try {
    const response: ResponseType = yield call(resourceService.post, API_URL + `/api/upgrade_classes/`, {school_id:Number(schoolId)});
    if (response.status == 200) {
      toast.success('Nâng lớp thành công');
      // yield put(setPreviewLoading(false));
    }
  } catch (error: any) {
    // yield put(setPreviewLoading(false));
  }
}

function* downloadTemplateAccountSchoolListSaga(action: ReturnType<typeof downloadTemplateAccountSchoolList>) {
  yield put(setLoadingDownloadTemplateSchool(true));
  const { schoolId } = action.payload;
  try {
      const response: ResponseType = yield call(
          fileService.get,
          API_URL + `/api/download-template-school-account-excel/?school=${schoolId}`,
          {
              responseType: 'blob' // Set response type to blob for binary data
          }
      );
      if (response.status === 200) {
          yield put(setTemplateSchoolFile(response.data));
      } else {
          toast.error('Tải file template thất bại: ' + response.data.error);
      }
  } catch (error: any) {
      console.log(error);
      toast.error('Tải file template thất bại: ' + (error.response?.data?.error || 'Lỗi không xác định'));
  } finally {
      yield put(setLoadingDownloadTemplateSchool(false));
  }
}

function* createSchoolModuleGradeSaga(action: ReturnType<typeof createSchoolModuleGrade>) {
  const { school_id, module_grade_id, schoolId } = action.payload;
  yield put(setLoadingSchoolModuleGrade(true));
  try {
    const response: ResponseType = yield call(
      resourceService.post,
      API_URL + '/api/school_module_grade/',
      { school_id, module_grade_id },
    );
    if (response.status === 200 || response.status === 201) {
      toast.success('Thêm môn học vào trường thành công');
      yield put(incrementSchoolModuleGradeSuccess());
      yield put(fetchSchoolModuleList(schoolId));
    }
  } catch (error: any) {
    const detail =
      error?.response?.data?.detail ||
      error?.response?.data?.message ||
      error?.message ||
      'Thêm môn học thất bại';
    toast.error(typeof detail === 'string' ? detail : 'Thêm môn học thất bại');
    console.error(error);
  } finally {
    yield put(setLoadingSchoolModuleGrade(false));
  }
}

function* deleteSchoolModuleGradeSaga(
  action: ReturnType<typeof deleteSchoolModuleGrade>,
): Generator<any, void, any> {
  const { school_id, school_module_grade, schoolId } = action.payload;
  yield put(setLoadingDeleteSchoolModuleGrade(true));
  try {
    const response: ResponseType = yield call(
      resourceService.delete,
      API_URL + '/api/school_module_grade/',
      { data: { school_id, school_module_grade } },
    );
    if (response.status === 200 || response.status === 204) {
      toast.success('Đã gỡ môn học khỏi trường');
      yield* reloadSchoolModuleListRows(String(schoolId));
    }
  } catch (error: any) {
    const detail =
      error?.response?.data?.detail ||
      error?.response?.data?.message ||
      error?.message ||
      'Gỡ môn học thất bại';
    toast.error(typeof detail === 'string' ? detail : 'Gỡ môn học thất bại');
    console.error(error);
  } finally {
    yield put(setLoadingDeleteSchoolModuleGrade(false));
  }
}

function* deleteSchoolSaga(
  action: ReturnType<typeof deleteSchool>,
): Generator<any, void, any> {
  const { id } = action.payload;
  yield put(setLoadingDeleteSchool(true));
  try {
    const response: ResponseType = yield call(
      resourceService.delete,
      API_URL + `/api/schools/${id}/`,
    );
    if (response.status === 204 || response.status === 200) {
      toast.success('Đã xóa trường học thành công.');
      yield put(setDeleteSchoolSuccess(true));
    }
  } catch (error: any) {
    const status = error?.response?.status;
    const detail = error?.response?.data?.detail;
    if (status === 400) {
      if (detail === 'Cannot delete school with associated classes.') {
        toast.error(
          'Không thể xóa trường vì trường vẫn còn lớp học liên kết.',
        );
      } else {
        toast.error(
          typeof detail === 'string' && detail.trim()
            ? detail
            : 'Yêu cầu không hợp lệ.',
        );
      }
    } else if (status === 403) {
      toast.error('Bạn không có quyền thực hiện thao tác này.');
    } else if (status !== 401) {
      const msg =
        error?.response?.data?.message ||
        error?.message ||
        'Xóa trường học thất bại';
      toast.error(typeof msg === 'string' ? msg : 'Xóa trường học thất bại');
    }
    console.error(error);
  } finally {
    yield put(setLoadingDeleteSchool(false));
  }
}

export default function* schoolSaga() {
  yield all([
    takeLatest(FETCHING_SCHOOL_LIST, fetchSchoolListData),
    takeLatest(CREATE_SCHOOL, createSchoolSaga),
    takeLatest(GET_SCHOOL_DETAIL, getSchoolDetailSaga),
    takeLatest(CLEAR_SCHOOL, clearSchoolSaga),
    takeLatest(UPDATE_SCHOOL, updateSchoolSaga),
    takeLatest(FETCH_SCHOOL_MODULES, fetchListSchoolModulesSaga),
    takeLatest(FETCHING_PROVINCE_LIST, fetchProviceListSaga),
    takeLatest(FETCHING_DISTRICT_LIST, fetchDistricListSaga),
    takeLatest(FETCHING_WARD_LIST, fetchWardListSaga),
    takeLatest(FETCH_SCHOOL_MODULES_LIST, fetchSchoolModuleListSaga),
    takeLatest(ADD_SCHOOL_MODULE, addSchoolModuleSaga),
    takeLatest(REMOVE_SCHOOL_MODULE, removeSchoolModuleSaga),
    takeLatest(FETCH_PERSONNEL_LIST_REQUEST, fetchPersonnelListSaga),
    takeLatest(FETCH_SCHOOL_YEARS_LIST, fetchSchoolYearListData),
    takeLatest(CREATE_SCHOOL_YEAR, createSchoolYearSaga),
    takeLatest(UPDATE_SCHOOL_YEAR, updateSchoolYearSaga),
    takeLatest(ASSIGN_SCHOOL_YEAR, assignSchoolYearSaga),
    takeLatest(FETCH_PREVIEW_UPGRADE_CLASS, fetchPreviewUpgradeClassesSaga),
    takeLatest(CONFIRM_UPGRADE_CLASS, confirmUpgradeClassSaga),
    takeLatest(FETCH_UPGRADE_CLASS_LOGS, fetchUpgradeClassesLogsSaga),
    takeLatest(DOWNLOAD_TEMPLATE_ACCOUNT_SCHOOL_LIST, downloadTemplateAccountSchoolListSaga),
    takeLatest(createSchoolModuleGrade.type, createSchoolModuleGradeSaga),
    takeLatest(deleteSchoolModuleGrade.type, deleteSchoolModuleGradeSaga),
    takeLatest(deleteSchool.type, deleteSchoolSaga),
  ]);
}
